import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import RiskStratificationTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/RiskStratificationTable';
import {
  formatRiskCost,
  formatRiskStratificationBreakDown,
  formatRiskUtilization,
  formatTriggerConditions,
} from '../core-utils/helper-utils/summaryReportHelper';
import { IceBurgChart } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { formatRiskStratificationData } from '../core-utils/helper-utils/riskProfileHelper';

const RiskStratification: React.FC<reportProps> = ({ data, isTable }) => {
  const [
    riskStratificationBreakDown,
    setRiskStratificationBreakDown,
  ] = useState<any>([]);
  const [
    riskStratificationCumulative,
    setRiskStratificationCumulative,
  ] = useState<any[]>([]);

  useEffect(() => {
    if (isTable) {
      const riskCost = formatRiskCost(data?.riskStratification?.riskCost);
      const riskUtilization = formatRiskUtilization(
        data?.riskStratification?.riskUtilization,
      );
      const riskTriggerConditions = formatTriggerConditions(
        data?.riskStratification?.riskTrigger,
      );
      setRiskStratificationBreakDown(
        formatRiskStratificationBreakDown(
          riskCost,
          riskUtilization,
          riskTriggerConditions,
        ),
      );
    } else {
      setRiskStratificationCumulative(
        formatRiskStratificationData(
          data?.riskStratification?.riskPrevalence,
          'chronic',
        ),
      );
    }
  }, []);
  return isTable ? (
    <RiskStratificationTable
      riskStratificationChartColumns={
        riskStratificationBreakDown.riskStratificationColumns
      }
      riskStratificationChartRows={
        riskStratificationBreakDown.riskStratificationRows
      }
      riskStratificationChartData={
        riskStratificationBreakDown.riskStratificationData
      }
    />
  ) : (
    <IceBurgChart
      tiersData={riskStratificationCumulative}
      indicatorWidth="380px"
      handleOnClick={() => {}}
    />
  );
};
export default RiskStratification;
